import { ModuleSection } from "@carfax/contentful/PageModularModule";
import { ModuleSectionGroup } from "@carfax/web-ui/components/ModuleSectionGroup";
import ModularPageComponentWrapper from "../ModularPageComponentWrapper";
import { isEven } from "utils/integer";

interface Props {
  module: ModuleSection;
  indexPosition: number;
}

export const ModuleSectionBlock = ({ module, indexPosition }: Props) => {
  return (
    <ModuleSectionGroup
      paddingTop={module.paddingTop}
      paddingBottom={module.paddingBottom}
      innerSpacing={module.innerSpacing}
    >
      {module.modules.map((nestedModule, nestedIndex) => (
        <ModularPageComponentWrapper
          key={`section-${indexPosition}-module-${nestedIndex}`}
          indexPosition={nestedIndex}
          moduleWrapper={nestedModule}
          showSecondaryImage={isEven(nestedIndex)}
        />
      ))}
    </ModuleSectionGroup>
  );
};
